import { useEffect, useState } from "react";
import "./Interview.scss";

export default function InterviewBadge({ text }) {
  const [isscrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    function handleScroll() {
      setIsScrolled(window.scrollY > 0);
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      {isscrolled && (
        <span className="interview-badge  bg-secondary m-2">{text}</span>
      )}{" "}
    </>
  );
}
